import { API } from '../../utils/amplifyWrapper';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assertFeatureCreditsOk } from '../organisation/featureCreditsGuard';

interface ICreateVoiceDesignParams {
    org_id: string;
    integration_id: string;
    voice_name: string;
    prompt: string;
    language_code: string;
    reference_audio_path?: string | null;
    settings?: Record<string, number>;
}

// Design/mix records live in the same cloned_voice table as clones (shared PK/SK), so
// list/poll continue to use useClonedVoices/fetchClonedVoiceById from useClonedVoice.ts —
// only creation needs a dedicated endpoint/payload shape.
export const useCreateVoiceDesign = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async ({
            org_id,
            integration_id,
            voice_name,
            prompt,
            language_code,
            reference_audio_path,
            settings,
        }: ICreateVoiceDesignParams) => {
            const response = await API.post(
                'main',
                `/organisation/${org_id}/integration/${integration_id}/voice_design`,
                {
                    body: {
                        voice_name,
                        prompt,
                        language_code,
                        reference_audio_path,
                        settings,
                    },
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            assertFeatureCreditsOk(response);
            return { voiceId: response.data.id as string, org_id, integration_id };
        },
        {
            onSuccess: ({ org_id, integration_id }) => {
                queryClient.invalidateQueries(['cloned_voices', org_id, integration_id]);
            }
        }
    );
};
